export default "__VITE_ASSET__Ec54B4mq__"